import React from 'react';

const AuthBackground = ({ image, caption }) => (
  <div className="auth-bg" aria-hidden="true">
    <img src={image.src} alt={image.alt} loading="lazy" />
    <div className="auth-bg-scrim" />
    {caption ? (
      <div className="auth-bg-caption">
        <span className="auth-bg-caption-label">{caption.label}</span>
        <span className="auth-bg-caption-divider" />
        <span className="auth-bg-caption-value">{caption.value}</span>
      </div>
    ) : null}
  </div>
);

export default AuthBackground;
